/* Built In Imports */
import React, { useEffect, useState } from 'react';
/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
import LazyLoadImageComponent from '@moms/Ui/LazyLoadImageComponent';
/* Styles */
import MakingMiracleSt from '@moms/styleData/MakingMiracleSt';
import MiraclePopup from '@moms/Ui/MiraclePopup';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const MakingMiracle = ({ sectionContent, region, lang }) => {
  const [navigatorObj, setNavigatorObj] = useState(true);
  let iOS = false;
  const making = sectionContent.find(el => el.fieldId === 'making');
  const miracle = sectionContent.find(el => el.fieldId === 'miracle');
  const ofMind = sectionContent.find(el => el.fieldId === 'of-mind');
  const sadhguruImg = sectionContent.find(el => el.fieldId === 'sadhguru-img');
  const media = sectionContent.find(el => el._modelApiKey === 'media_embed');
  const iPhoneScreenHide = () => {
    var elVideo = document.getElementById('hideiOSVideo');
    iOS = /iPad|iPhone|iPod/.test(navigator?.userAgent) && !window.MSStream;
    // console.log('iOS', iOS, navigator.userAgent);
    setNavigatorObj(navigator.userAgent);
    if (iOS) {
      elVideo.style.display = 'none';
    }
  };
  useEffect(() => {
    iPhoneScreenHide();
  }, []);
  const SingleLineText = ({ text, style }) => {
    return (
      <Text textAlign="right" {...style}>
        {text}
      </Text>
    );
  };
  // const PlayButton = ({ url }) => {
  //   return (
  //     <NextLink
  //       href={refineUrlDomain(url, region, lang)}
  //       target="_blank"
  //       passHref
  //     >
  //       <Link>
  //         <Center
  //           width={90}
  //           h={90}
  //           _hover={{ bg: '#DBDBDB' }}
  //           bg="#FDFDFD"
  //           color="#EC1B2E"
  //           rounded="full"
  //           fontSize="50px"
  //         >
  //           <IoPlaySharp style={{ marginRight: '-5px' }} />
  //         </Center>
  //       </Link>
  //     </NextLink>
  //   );
  // };
  return (
    <Box
      w="100%"
      bg="#000"
      py={{ base: '80px', md: '125px' }}
      bgImage={`${config.imgPath}/d/46272/1738915800-transition-motion-1.png`}
      bgPos="center"
      bgRepeat="no-repeat"
      bgSize="cover"
      pos="relative"
      _after={{
        content: "''",
        pos: 'absolute',
        height: '0.6px',
        left: '0',
        right: '0',
        width: '100%',
        bottom: '0',
        zIndex: '1',
        background:
          'radial-gradient(80.14% 21.43% at 50% 50%, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 100%), #010102',
        backdropFilter: 'blur(calc(var(--sds-size-blur-100) / 2))',
        borderTop: '1px solid rgba(255, 255, 255, 0.20)',
      }}
      px={{ md: '1rem' }}
    >
      <Box
        pos="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        w="100%"
        height="100%"
        id="hideiOSVideo"
        zIndex={1}
      >
        <Box
          as="video"
          width="100%"
          height="100%"
          loop
          muted
          autoPlay
          objectFit="cover"
        >
          <source
            src={`${config.imgPath}/d/46272/1740037482-2e44110987c19d60014c9e57cb34972f.mp4`}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </Box>
      </Box>
      <Box
        w="100%"
        maxW={1150}
        mx="auto"
        px={{ md: '1rem' }}
        pos="relative"
        zIndex={2}
      >
        <Flex
          gap={{ base: '5%', lg: '10%' }}
          flexDir={{ base: 'column-reverse', md: 'row' }}
          alignItems="flex-end"
          w="100%"
        >
          <Flex
            flex={1}
            alignItems="flex-end"
            mr={{ base: '2rem', md: '0' }}
            flexDir="column"
            pt={{ base: '0', md: '30%' }}
            maxW={{ base: 'none', lg: '400px' }}
            mt={{ base: '-60px', md: '0' }}
            position="relative"
            w={{ base: '100%', md: '50%' }}
          >
            <Box mb="1.5rem" position="relative" zIndex="1">
              <MiraclePopup media={media} />
            </Box>
            <SingleLineText
              text={making.text}
              style={MakingMiracleSt[lang].makingText}
              wordWrap=""
            />
            <SingleLineText
              text={miracle.text}
              style={MakingMiracleSt[lang].miracleText}
            />
            <SingleLineText
              text={ofMind.text}
              style={MakingMiracleSt[lang].ofMindText}
            />
          </Flex>
          <LazyLoadImageComponent
            height={{ base: '398px', md: '586px' }}
            maxH={{ base: '398px', lg: '100%' }}
            mr={{ base: 'auto', md: '0' }}
            flex={1}
            maxW={{ base: 310, md: '452px' }}
            minH={310}
            // w="auto"
            objectFit="cover"
            w={{ base: '100%', md: '50%' }}
            position="relative"
            zIndex="0"
            objectPosition="center"
            src={sadhguruImg.image.url}
            alt={sadhguruImg.image.alt}
          />
        </Flex>
      </Box>
    </Box>
  );
};

export default MakingMiracle;
